import { subscriptionRepository } from '../repositories/subscription-repository';

async function createSubscription(body) {
    if (!body.plan) {
        throw Error('Invalid parameters');
    }

    return subscriptionRepository.create(body, true);
};

export {
    createSubscription
}
